/**
 * The marketing site (llmr-website) is a separate app on a different
 * subdomain — the reverse of llmr-website's own src/lib/memberPortal.ts,
 * which links the other way. Host comes from a Docker build-arg per
 * environment (see devops/Dockerfile, devops/{develop,uat}/jenkins-deploy), exposed to
 * the client bundle via the `PUBLIC_` envPrefix in vite.config.ts.
 *
 * This is the one baked-in value in an otherwise config-free SPA (see
 * devops/develop/env.dev.sample) — it names a sibling *app*, not this app's
 * own API origin, so it does not touch the same-origin API contract in
 * README.md. A local `npm run dev` has no such build-arg, so this returns
 * `null` and the caller renders no link rather than guessing a host.
 */
export function websiteUrl(): string | null {
  const host = import.meta.env.PUBLIC_WEBSITE_HOST;
  if (!host) return null;
  const scheme = host.startsWith('localhost') ? 'http' : 'https';
  return `${scheme}://${host}/`;
}
